<template>
  <span class="active-status" v-if="user" :style="{ backgroundColor: color }">
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'UserActiveStatusTag',
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  computed: {
    color() {
      return this.user.active ? 'forestgreen' : 'indianred'
    },
    label() {
      return this.user.active ? 'ACTIVE' : 'INACTIVE'
    },
  },
}
</script>
<style>
.active-status {
  background-color: indianred;
  color: white;
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}
</style>
